import { copyToClipboard } from '@utils/copy-to-clipboard';
import NotebookMixin from './notebook-mixin';

export default {
  mixins: [NotebookMixin],

  data() {
    return {
      cloneToast: undefined,
      repoAccessToken: undefined,
      repoReady: true,
    };
  },
  methods: {
    getHttpUrl(url) {
      return `${url.substring(0, 8)}oauth2:${this.repoAccessToken}@${url.substring(8)}`;
    },
    copyHttp(url) {
      copyToClipboard(this.getHttpUrl(url));
    },
    copySsh(url) {
      copyToClipboard(url);
    },
  },
};
